export const labels = {
	remove: {
		label: "Label.MobileCreator.SpreadOverview.Spread.Remove",
		default: "Remove",
	},
};
